import React, { useState, useRef, useEffect, useMemo } from "react";
import { getEvents, useProjections } from "../../_actions/eventsActions";
import EventsSlider from "@/components/event/EventsSlider";
import Projections from "@/components/film/Projections";
import { motion, AnimatePresence } from "framer-motion";
import { useBreakPoints } from "@/constants/breakpoinst";
import { format, add } from "date-fns";
import { atom, useAtom, useAtomCallback } from "jotai";
import {
  calendarAtom,
  dayAtom,
} from "@/components/navigation/ScrollingCalendar";
import { generateSkeletons } from "@/components/lib/Skeletons";

import * as Text from "@/components/text";

export default function OnsiteEvents() {
  const breakpoint = useBreakPoints();
  const [events, setEvents] = useState({});

  const [venuesArray, setVenuesArray] = useState([]);
  const [calendarData, setCalendarData] = useAtom(calendarAtom);
  const [day, setDay] = useAtom(dayAtom);
  const [eventsByVenue, setEventsByVenue] = useState({});

  const now = useMemo(() => new Date(), []);
  const tomorrow = add(new Date(), { days: 2 });
  const todayEnd = format(new Date(tomorrow).setHours(0), "yyy-MM-dd");

  useEffect(() => {
    getEvents().then((res) => {
      setEvents(res.data);
    });
  }, []);

  const {
    data: projections,
    error: projectionsError,
    loading: projectionsLoading,
  } = useProjections({
    live_screenings: {
      date: {
        $gte: now,
      },
    },
  });

  useEffect(() => {
    if (events && projections) {
      let cal = [];
      let x = {};

      events?.data?.forEach((element) => {
        if (!element?.attributes?.sede?.data?.attributes?.states) {
          x["Sin sede"] = [element];
        } else {
          if (element?.attributes?.sede?.data?.attributes.name in x) {
            x[element?.attributes?.sede?.data?.attributes.name].push(element);
          } else {
            x[element?.attributes?.sede?.data?.attributes.name] = [element];
          }
        }
      });

      const newProjections = projections.data.map((projection) => {
        let date_time = projection.attributes.live_screenings[0].date;
        let event_admission_fee =
          projection.attributes.live_screenings[0].admission_fee;

        projection.attributes.date_time = date_time;
        projection.attributes.event_admission_fee = event_admission_fee;
        projection.attributes.films = projection.attributes.peliculas;

        return {
          ...projection,
        };
      });

      newProjections.forEach((element) => {
        if (!element?.attributes?.sede?.data) {
          x["Sin sede"] = [element];
        } else {
          if (element?.attributes?.sede?.data?.attributes.name in x) {
            x[element?.attributes?.sede?.data?.attributes.name].push(element);
          } else {
            x[element?.attributes?.sede?.data?.attributes.name] = [element];
          }
        }
      });

      setEventsByVenue(x);

      events?.data?.forEach((element) => {
        if (!element?.attributes?.sede?.data?.attributes.states) {
          if (cal.find((e) => e.title === "Sin sede")) {
            cal
              .find((e) => e.title === "Sin sede")
              .days.push(
                format(new Date(element.attributes.date_time), "dd-M")
              );
            cal
              .find((e) => e.title === "Sin sede")
              .trueDays.push(element.attributes.date_time);
          } else {
            cal.push({
              title: "Sin sede",
              days: [format(new Date(element.attributes.date_time), "dd-M")],
              trueDays: [element.attributes.date_time],
            });
            return;
          }
        } else {
          if (
            cal.find(
              (e) =>
                e.title === element?.attributes?.sede?.data?.attributes.states
            )
          ) {
            if (
              cal
                .find(
                  (e) =>
                    e.title ===
                    element?.attributes?.sede?.data?.attributes.states
                )
                .days.includes(
                  format(new Date(element.attributes.date_time), "dd-M")
                )
            ) {
              return;
            } else {
              cal
                .find(
                  (e) =>
                    e.title ===
                    element?.attributes?.sede?.data?.attributes.states
                )
                .days.push(
                  format(new Date(element.attributes.date_time), "dd-M")
                );
              cal
                .find(
                  (e) =>
                    e.title ===
                    element?.attributes?.sede?.data?.attributes.states
                )
                .trueDays.push(element.attributes.date_time);
            }
          } else {
            if (element?.attributes?.sede?.data?.attributes.states === null) {
              debugger;
            }
            cal.push({
              title: element?.attributes?.sede?.data?.attributes.states,
              days: [format(new Date(element.attributes.date_time), "dd-M")],
              trueDays: [element.attributes.date_time],
            });
          }
        }
      });

      newProjections.forEach((element) => {
        if (!element.attributes.sede?.data?.attributes?.states) {
          if (cal.find((e) => e.title === "Sin sede")) {
            if (
              cal
                .find((e) => e.title === "Sin sede")
                .days.includes(
                  format(new Date(element.attributes.date_time), "dd-M")
                )
            ) {
              return;
            } else {
              cal
                .find((e) => e.title === "Sin sede")
                .days.push(
                  format(new Date(element.attributes.date_time), "dd-M")
                );
              cal
                .find((e) => e.title === "Sin sede")
                .trueDays.push(element.attributes.date_time);
            }
          } else {
            cal.push({
              title: "Sin sede",
              days: [format(new Date(element.attributes.date_time), "dd-M")],
              trueDays: [element.attributes.date_time],
            });
          }
        } else {
          if (
            cal.find(
              (e) =>
                e.title === element?.attributes?.sede?.data?.attributes.states
            )
          ) {
            const state = cal.find(
              (e) =>
                e.title === element?.attributes?.sede?.data?.attributes.states
            );
            if (
              cal
                .find(
                  (e) =>
                    e.title ===
                    element?.attributes?.sede?.data?.attributes.states
                )
                .days.includes(
                  format(new Date(element.attributes.date_time), "dd-M")
                )
            ) {
              return;
            } else {
              cal
                .find(
                  (e) =>
                    e.title ===
                    element?.attributes?.sede?.data?.attributes.states
                )
                .days.push(
                  format(new Date(element.attributes.date_time), "dd-M")
                );
              cal
                .find(
                  (e) =>
                    e.title ===
                    element?.attributes?.sede?.data?.attributes.states
                )
                .trueDays.push(element.attributes.date_time);
            }
            return;
          } else {
            cal.push({
              title: element?.attributes?.sede?.data?.attributes.states,
              days: [format(new Date(element.attributes.date_time), "dd-M")],
              trueDays: [element.attributes.date_time],
            });
          }
        }
      });
      setCalendarData(cal);
    }
  }, [events, projections, setCalendarData]);

  useEffect(() => {
    if (eventsByVenue && Object.keys(eventsByVenue).length > 0) {
      setVenuesArray(Object.keys(eventsByVenue));
    }
  }, [eventsByVenue]);

  return (
    <>
      {venuesArray.length > 0 ? (
        venuesArray.map((venue) => (
          <>
            {breakpoint !== "sm" ? (
              <>
                <EventsSlider
                  events={eventsByVenue[venue].filter(
                    (event) =>
                      format(new Date(event?.attributes.date_time), "dd-M") ===
                      day
                  )}
                  venueName={venue}
                />
              </>
            ) : (
              <>
                {eventsByVenue[venue].filter(
                  (event) =>
                    format(new Date(event?.attributes.date_time), "dd-M") ===
                    day
                ).length ? (
                  <div key="venue" className="my-5 gap-16 space-y-10 ">
                    <Text.Title className="font-bold normal-case" size="md">
                      {venue}
                    </Text.Title>
                  </div>
                ) : null}
                {eventsByVenue[venue]
                  .filter(
                    (event) =>
                      format(new Date(event?.attributes.date_time), "dd-M") ===
                      day
                  )
                  .map((event) => (
                    <>
                      <div
                        key={event.id}
                        className="mr-5 h-auto w-full md:w-[500px] "
                      >
                        <Projections
                          fullDate={false}
                          label={event?.attributes.event_type || "Proyección"}
                          movie_title={
                            event?.attributes?.event_name ||
                            event?.attributes?.title
                          }
                          showTitle={true}
                          showImage={false}
                          view_more={
                            event?.attributes?.live_screenings
                              ? `/catalogo/${event?.attributes?.films?.data[0]?.attributes.filmSlug}`
                              : `/calendario/${event.id}`
                          }
                          movie_link={
                            event?.attributes?.live_screenings
                              ? ""
                              : `/calendario/${event.id}`
                          }
                          movie={event?.attributes.films.data[0]}
                          image={
                            event?.attributes?.event_image?.data?.attributes
                              ?.url ||
                            event?.attributes?.films?.data[0]?.attributes
                              ?.film_cover_image?.data?.attributes?.url
                          }
                          film_projections={{
                            maps_url:
                              event?.attributes?.sede?.data?.attributes
                                ?.venue_map_url,
                            type: "onSite",
                            from_date: event?.attributes.date_time,
                            to_date: event?.attributes.date_time,
                            cost: event?.attributes.event_admission_fee,
                            venue:
                              event?.attributes?.sede?.data?.attributes?.name ||
                              "",
                            city:
                              event?.attributes?.sede?.data?.attributes
                                ?.states || "",
                          }}
                        />
                      </div>
                    </>
                  ))}
              </>
            )}
          </>
        ))
      ) : (
        <div className="grid-cols-3 md:grid ">{generateSkeletons(3)}</div>
      )}
    </>
  );
}
